// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useRef, useMemo, Fragment, useState, useContext,
    useEffect} from 'react';
import cn from 'classnames';
import {use_section_scroll} from '../../lib/use_section_scroll';
import {Settings_context, use_theme} from '../../settings_ctx';
import {Colored_text, t_colors} from '../../ui/about/colored_text';
import {Media_block, i_media_block_props} from '../../ui/media_block';
import styles from './about_us.module.less';
import {Cards, i_card, i_cls_obj} from '../../ui/cards';
import {use_element_size} from '../../lib/screen_util';
import {Lottie} from '../../lib/lottie';
import {use_screen} from '../../lib/screen_util';
import {img_url} from '../../ui/img_url';
// @ts-ignore
import {App_context} from '/www/hola/pub/context.js';

const About_hero = ()=>{
    const lines: [string, t_colors][] = [
        ['Internet Freedom.', 'blue'],
        ['It’s what we’re about.', 'pink'],
        ['It is who we are.', 'yellow'],
    ];
    return <h1 className={styles.hero}>
      {lines.map(([s, c], i)=><Colored_text key={i} text={s} color={c}/>)}
    </h1>;
};

const About_info = ()=>{
    return <section className={styles.info}>
      <div className={styles.col}>
        <p className={styles.title}>4.9 stars</p>
        <p className={styles.text}>in Chrome Web Store</p>
      </div>
      <div className={styles.col}>
        <p className={styles.title}>263 million</p>
        <p className={styles.text}>downloads and counting</p>
      </div>
      <div className={styles.col}>
        <p className={styles.title}>195 countries</p>
        <p className={styles.text}>to browse from</p>
      </div>
    </section>;
};

const Access_for_all_block = (props: i_media_block_props)=>{
    const ref = useRef();
    use_section_scroll(ref, false);
    return <Media_block ref={ref} {...props}/>;
};
const Access_for_all = ({is_mobile})=>{
    const {theme} = use_theme();
    let democracy = 'about/democracy.svg';
    let borderless = 'about/borderless.svg';
    if (is_mobile)
    {
        democracy = 'about/democracy_mobile.svg';
        borderless = 'about/borderless_mobile.svg';
    }
    const media: i_media_block_props[] = [
        {
            img: democracy,
            title: 'Hola believes in Online Democracy',
            text: `The team behind Hola is driven by Innovation, Online
            Democracy and Internet Freedom. We believe in Worldwide Online
            Access for All.`,
            reversed: false,
            cls: {container: styles.access_for_all_block, img: styles.img,
                text: theme.p2},
        },
        {
            img: borderless,
            title: 'We are committed to creating a Borderless Internet.',
            text: `Think of Hola as your passport that gets you visa-free
            Online Access to truly Worldwide content. This is our ultimate
            destination.`,
            reversed: true,
            cls: {container: styles.access_for_all_block, img: styles.img,
                text: theme.p2},
        },
    ];
    return <section className={styles.access_for_all_section}>
      {media.map(props=><Access_for_all_block key={props.img} {...props}/>)}
    </section>;
};

const About_product = ()=>{
    const {theme} = use_theme({def: 'hola2023'});
    const cards: i_card[] = useMemo(()=>{
        const ids = ['ext', 'mobile', 'desktop', 'tv', 'others'];
        const data = {
            ext: {
                title: 'Browser Extensions',
                to: '/products/extension',
            },
            mobile: {
                title: 'Phone Apps',
                to: '/products/mobile',
            },
            desktop: {
                title: 'Desktop Apps',
                to: '/products/desktop',
            },
            tv: {
                title: 'TV Apps',
                to: '/products/tv',
            },
            others: {
                title: 'More Products',
                to: '/products/console',
            },
        };
        return ids.map(id=>({
            id,
            img: `hola2023/products_discover_${id}.svg`,
            clickid: `about_us_products_${id}`,
            ...data[id],
        }));
    }, []);
    const cls: i_cls_obj = {
        container: styles.cards_container,
        card: styles.product_card,
        title: cn(theme.u3, styles.card_title),
        img: styles.card_img,
  };
    return <section className={styles.products}>
        <p className={cn(theme.p1, styles.title_p)}>{'Hola everywhere :)'}</p>
        <h3 className={cn(theme.h3, styles.products_h3)}>
            Get the access you want on any device
        </h3>
            <Cards cards={cards} cls={cls}/>
    </section>;
};

const About_media = ()=>{
    const {theme} = use_theme({def: 'hola2023'});
    const media_cards = useMemo(()=>{
        const ids = ['press', 'media', 'blog'];
        const data = {
            press: {
                title: 'Press kit',
                text: <Fragment>Get Hola's branding<br/>assets</Fragment>,
                btn: {
                    to: '/static/press_kit/press_kit.zip',
                    clickid: 'about_us_media_block_press',
                    round: true,
                    caption: 'Download archive',
                    color: 'transparent',
                    as_external: true,
                },
            },
            media: {
                title: 'Hola in the media',
                text: <Fragment>Lights, camera, action<br/>
                    (and some cool articles too)</Fragment>,
                btn: {
                    to: '/media',
                    clickid: 'about_us_media_block_media',
                    round: true,
                    caption: 'Read articles',
                    color: 'transparent',
                },
            },
            blog: {
                title: 'Hola blog',
                text: 'Hear about what we\'ve got going on',
                btn: {
                    to: '/blog',
                    clickid: 'about_us_media_block_blog',
                    round: true,
                    caption: 'Go to Blog',
                    color: 'transparent',
                },
            },
        };
        return ids.map(id=>({
            id,
            img: `about/${id}.svg`,
            clickid: `about_us_media_card_${id}`,
            ...data[id],
        }));
    }, []);
    const cls: i_cls_obj = {
        container: styles.media_cards_container,
        card: styles.media_card,
        title: cn(theme.p1, styles.media_card_title),
        text: cn(theme.p2, styles.media_card_text),
    };
    return <section className={styles.media_section}>
        <p className={cn(theme.p1, styles.title_p)}>More Hola?</p>
        <h3 className={cn(theme.h3, styles.media_h3)}>
            Check out what folks are saying about us
        </h3>
        <Cards cards={media_cards} cls={cls}/>
    </section>;
};

const Timeline_animation = ()=>{
    const {theme} = useContext(Settings_context);
    const anim = useRef();
    // @ts-ignore
    const {is_client} = useContext(App_context);
    const animation = [
        {frames: {from: 0, to: 125}, direction: 1, loop: false},
    ];
    const [w, h] = use_element_size(is_client && {
        xs: [375, 108],
        sm: [375, 108],
        md: [600, 225],
        all: [800, 300],
    });
    const from = useRef(0);
    const [to, set_to] = useState(0);
    const {width} = use_screen();
    const events = [
        {
            frame: 0,
            text: `Hola says Hola! to the world and
                kickstarts its commitment to a Better Internet for All.`,
        },
        {
            frame: 25,
            text: `Building on the great response since launch, Hola expands
                its product range to include even more of your favorite
                devices!`,
        },
        {
            frame: 50,
            text: `Hola hits its stride with 100 million downloads, further
                enhancing the goal of bringing a Borderless Internet to life!`,
        },
        {
            frame: 75,
            text: `Pandemics...lockdowns... Hola launches apps for Smart TVs,
                which is pretty smart, considering!`,
        },
        {
            frame: 100,
            text: `Hola breaks its own record, getting to 200 million
                downloads. Our love for our users is now 200 million strong!`,
        },
        {
            frame: 125,
            text: `The Hola brand gets a fresh update, creating a more
                engaging and exciting look, with an enhanced user experience
                for all.`,
        },
    ];
    const lottie = width > 764 ? 'animation/about_timeline.json' :
        'animation/about_timeline_mobile.json';
    const on_prev = ()=>{ set_to(v=>v-25); };
    const on_next = ()=>{ set_to(v=>v+25); };
    useEffect(()=>{
        if (to==from.current || !anim.current)
            return;
        // @ts-ignore
        anim.current._lottie.playSegments([[from.current, to]], true);
        from.current = to;
    }, [to, anim.current]);
    return <div className={styles.timeline}>
      {events.map(({frame, text})=>{
          const event_cls = cn(styles.event, {
              [styles.before]: frame<to && styles.before,
              [styles.active]: frame==to && styles.active,
              [styles.after]: frame>to && styles.after,
          }, width <= 764 ? theme.p2 : null);
          return <p key={frame} className={event_cls}>
            {text}
          </p>;
      })}
      <Lottie src={img_url(lottie)} width={w} key={lottie}
        height={h} animation={animation} timeout={0} fixed_frame={0}
        on_create={l=>{ anim.current = l; }}/>
      <div className={styles.controls}>
        <button className={styles.prev} disabled={to==0}
          onClick={on_prev}>PREV</button>
        <button className={styles.next} disabled={to==125}
          onClick={on_next}>NEXT</button>
      </div>
    </div>;
};

const About_calendar = ()=>{
    const {width} = use_screen();
    const title = width > 764 ? 'So it all started in 2012....' :
        <>So it all started<br/>in 2012....</>;
    return <div className={styles.about_calendar}>
      <h3 className={styles.about_title}>{title}</h3>
      <Timeline_animation/>
    </div>;
};

export const Root = ({client_hints})=>{
    const {theme} = use_theme();
    const root_cls = cn(theme.root, styles.root);
    return <div className={root_cls}>
      <div className={styles.container}>
        <div className={styles.hero_info_wrapper}>
            <About_hero/>
            <About_info/>
        </div>
        <Access_for_all is_mobile={client_hints.platform.mobile}/>
        <About_calendar/>
        <About_product/>
        <About_media/>
      </div>
    </div>;
};

Root.meta = {
    meta: {
        title: 'Hola For All Devices For Free or at a Reasonable Price '
            +'Online - About Us',
        description: 'We\'re (Hola) the first community-powered or P2P '
            +'network provider helping to make the web more open and '
            +'accessible with added privacy and security features for all.',
        canonical_url: 'https://hola.org/about',
    },
    nosearch: true,
    no_ssr: true,
    default_theme: 'hola2023',
};
